import { render } from "./SchoolActivationForm.vue?vue&type=template&id=57bae01c&ts=true"
import script from "./SchoolActivationForm.vue?vue&type=script&lang=ts"
export * from "./SchoolActivationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__